module.exports = __webpack_public_path__ + "static/img/banner2.17c2a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = y5LZ
// module chunks = 0